import Grid from "@mui/material/Unstable_Grid2";

const About = () => {
    return (
        <Grid container spacing={2} sx={{ml: 2, mt: 5, mr: 2, mb: 2}}>
            <Grid>
                <h1>Legal Disclosure (Impressum)</h1>
                <section>
                    <h2>Information according to § 5 DDG</h2>
                    <p>
                        Silvio Ciavarrella<br/>
                        Alter Schulhof 2<br/>
                        89597 Munderkingen<br/>
                        Germany
                    </p>
                    <p>
                        Legal Form: Sole Proprietor<br/>
                        VAT ID No.: DE446069721
                    </p>

                    <h2>Contact</h2>
                    <p>
                        Phone: +49 173 7046564<br/>
                        Email: support&#64;nasbai.com
                    </p>
                    <p>
                        Responsible for content according to § 18 para. 2 MStV:<br/>
                        Silvio Ciavarrella, address as above.
                    </p>
                    <p>
                        Digital Services Act (DSA) – Point of Contact
                        In accordance with Articles 11 and 12 of the EU Digital Services Act (DSA), users and
                        authorities can contact us at:
                        Email: support@nasbai.com
                        We can communicate in English and German.
                    </p>

                    <h1>Disclaimer</h1>

                    <h2>Liability for Content</h2>
                    <p>
                        The contents of our website have been created with the utmost care. However, we cannot guarantee
                        the accuracy,
                        completeness, or timeliness of the content. As a service provider, we are responsible for our
                        own content on these
                        pages in accordance with general laws as per § 7 para.1 DDG. However, according to §§ 8 to 10
                        DDG, we are not
                        obligated as a service provider to monitor transmitted or stored external information or to
                        investigate circumstances
                        indicating illegal activity. Obligations to remove or block the use of information under general
                        laws remain unaffected
                        by this. However, liability in this regard is only possible from the time of knowledge of a
                        specific legal violation.
                        Upon becoming aware of such legal violations, we will remove the content immediately.
                    </p>

                    <h2>Liability for Links</h2>
                    <p>
                        Our website contains links to external third-party websites over which we have no influence.
                        Therefore, we cannot accept
                        any liability for these external contents. The respective provider or operator of the linked
                        pages is always responsible
                        for their content. The linked pages were checked for possible legal violations at the time of
                        linking. No illegal content
                        was identifiable at the time of linking. Permanent monitoring of the content of linked pages is
                        not reasonable without
                        concrete evidence of a legal violation. If we become aware of any legal infringements, we will
                        remove such links immediately.
                    </p>

                    <h2>Copyright</h2>
                    <p>
                        The content and works created by the website operators on these pages are subject to German
                        copyright law.
                        Reproduction, editing, distribution, and any kind of exploitation outside the limits of
                        copyright law require the
                        written consent of the respective author or creator. Downloads and copies of this site are only
                        permitted for
                        private, non-commercial use. Insofar as the content on this site was not created by the
                        operator, the copyrights of
                        third parties are respected. In particular, third-party content is marked as such. If you still
                        notice a copyright
                        infringement, please let us know. If we become aware of legal violations, we will remove such
                        content immediately.
                    </p>
                </section>
            </Grid>
        </Grid>
    )
}

export default About;